"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-MultiListSearch',
    icon: 'c-MultiListSearch__icon',
    input: 'c-MultiListSearch__input',
    clear: 'c-MultiListSearch__clear',
};
exports.Style = {
    [exports.CSS.container]: {
        display: 'flex',
        width: '100%',
        height: '28px',
        'align-items': 'center',
        'margin-bottom': theme_1.DefaultTheme.space(4),
        padding: `0 ${theme_1.DefaultTheme.space(2)}`,
        'background-color': theme_1.DefaultTheme.background.lightGrey,
    },
    [exports.CSS.input]: {
        flex: '1',
        outline: 'none',
        'font-family': theme_1.DefaultTheme.font.family,
        'font-size': theme_1.DefaultTheme.font.size,
        width: '100%',
        border: `${theme_1.DefaultTheme.space(1)} solid transparent`,
        'padding-left': theme_1.DefaultTheme.space(1),
        'margin-left': theme_1.DefaultTheme.space(4),
        'background-color': 'transparent',
    },
    [`${exports.CSS.input}::placeholder`]: {
        opacity: '0.6',
        transition: 'opacity 0.2s ease',
    },
    [`${exports.CSS.input}:focus::placeholder`]: {
        opacity: '0.8',
    },
    [exports.CSS.icon]: {
        'pointer-events': 'none',
    },
};
//# sourceMappingURL=multi.list.search.style.js.map